<template>
    <v-card
        class="mx-auto"
        max-width="500"
        outlined
        elevation="2"
    >
        <v-form @submit.prevent="submit">
            <v-card-title class="justify-center">{{ $t('views.auth.forgot_password.password_recovery') }}</v-card-title>
            <v-divider></v-divider>

            <v-card-text class="text-center" v-if="!completed">
                {{ $t('views.auth.forgot_password.instructions') }}
            </v-card-text>
            <v-card-text v-if="!completed">
                <v-text-field
                    v-model="form.email"
                    :label="$t('views.auth.forgot_password.email_label')"
                    maxlength="255"
                    :error="$store.getters.hasValidationError('email')"
                    :error-messages="$store.getters.validationError('email')"
                ></v-text-field>
            </v-card-text>
            <v-card-actions class="d-flex justify-end" v-if="!completed">
                <v-btn type="submit" color="success" block rounded :loading="passwordRecoveryEmailSending">
                    {{ $t('views.auth.forgot_password.send_link_button') }}
                </v-btn>
            </v-card-actions>

            <v-card-text class="text-center" v-if="completed">
                <v-alert
                    outlined
                    type="success"
                >
                    {{ $t('views.auth.forgot_password.recovery_link_sent') }}
                </v-alert>
            </v-card-text>

            <v-card-text class="text-center">
                <router-link :to="{name: 'register'}">
                    {{ $t('views.auth.forgot_password.register_link') }}
                </router-link>
                |
                <router-link :to="{name: 'login'}">
                    {{ $t('views.auth.forgot_password.login_link') }}
                </router-link>
            </v-card-text>
        </v-form>
    </v-card>
</template>

<script>
    export default {
        name: "ForgotPassword",

        data() {
            return {
                passwordRecoveryEmailSending: false,
                completed: false,

                form: {
                    email: null,
                },
            };
        },

        methods: {
            submit: function() {

                if(this.passwordRecoveryEmailSending) {
                    return;
                }

                this.passwordRecoveryEmailSending = true;

                this.$store.dispatch('sendPasswordRecoveryEmail', this.form)
                    .then(response => {
                        if(response.status !== 200) {
                            this.$store.commit(
                                "showSnackbarError",
                                this.$t('views.auth.forgot_password.recovery_link_sending_failed')
                            );
                            return;
                        }

                        this.completed = true;
                    })
                    .catch(() => {})
                    .then(() => {
                        this.passwordRecoveryEmailSending = false;
                    });
            },
        },
    }
</script>

<style scoped>

</style>
